module.exports = __webpack_public_path__ + "img/zanwuranqibiao.9ddeefe4.png";